import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';


export abstract class FragmentService {

  public abstract retrieveFragment(
    slug: string,
    country?: string,
    lang?: string,
    device?: string,
    timeTravelTo?: string,
    userFlags?: string): Observable<string>;

}

export const FRAGMENT_SERVICE_TOKEN = new InjectionToken<FragmentService>('FragmentService');
